import qs from 'qs'

export function buildQueryParams(params) {
  const filteredParams = Object.keys(params).reduce((acc, key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      if (Array.isArray(value) && value.length === 0) {
        return acc;
      }
      acc[key] = value;
    }
    return acc;
  }, {});
  return qs.stringify(filteredParams, { arrayFormat: 'repeat' });
}